import { render, staticRenderFns } from "./LmUploadFiles.vue?vue&type=template&id=71120070&scoped=true&"
import script from "./LmUploadFiles.vue?vue&type=script&lang=js&"
export * from "./LmUploadFiles.vue?vue&type=script&lang=js&"
import style0 from "./LmUploadFiles.vue?vue&type=style&index=0&id=71120070&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71120070",
  null
  
)

export default component.exports